import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import { BvEvent } from "bootstrap-vue";
import { NavMenuItem } from "@medapro-types/common/common";
import { computed, reactive } from "vue";

//#region General
type Props = { split: boolean; level: number; buttonLabel?: string; icon?: string; items: Array<NavMenuItem>; modalName?: string; disabled?: boolean };
type ViewModel = { isNestedDropdownVisible: boolean };

export default /*#__PURE__*/_defineComponent({
  __name: 'MultiLevelDropDownButton',
  props: {
    split: { type: Boolean },
    level: {},
    buttonLabel: {},
    icon: {},
    items: {},
    modalName: {},
    disabled: { type: Boolean }
  },
  emits: ["click", "show", "hide"],
  setup(__props: any, { emit }) {

const props = __props;



//#endregion

//#region ViewModel
const viewModel = reactive<ViewModel>({ isNestedDropdownVisible: false });
//#endregion

//#region Computed Properties
const dropDownID = computed(() => "dropdown-level-" + props.level);
//#endregion

//#region Methods
const itemClicked = (item: NavMenuItem | null) => {
  emit("click", item);
};
const onDropdownShow = (bvEvent: BvEvent) => {
  emit("show", bvEvent);
  if (bvEvent.componentId !== "dropdown-level-1") {
    viewModel.isNestedDropdownVisible = true;
  }
};
const onDropdownHide = (bvEvent: BvEvent) => {
  emit("hide", bvEvent);
  if (bvEvent.componentId !== "dropdown-level-1") {
    viewModel.isNestedDropdownVisible = false;
  }
  if (viewModel.isNestedDropdownVisible) {
    bvEvent.preventDefault();
  }
};
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_multi_level_drop_down_button = _resolveComponent("multi-level-drop-down-button", true)!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _directive_safe_class = _resolveDirective("safe-class")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (_openBlock(), _createBlock(_component_b_dropdown, {
    "toggle-class": "mono",
    "split-class": "mono",
    "split-button-type": "button",
    "menu-class": "multi-level-dropdown",
    class: _normalizeClass({ 'split-button': _ctx.split == true }),
    disabled: props.disabled,
    dropright: props.level > 1,
    split: props.split,
    id: dropDownID.value,
    text: props.buttonLabel,
    offset: props.level > 1 ? -5 : 0,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (itemClicked(null))),
    onShow: onDropdownShow,
    onHide: onDropdownHide
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!item.items)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: index,
                disabled: item.disabled,
                onClick: ($event: any) => (itemClicked(item)),
                "link-class": "menu-option"
              }, {
                default: _withCtx(() => [
                  (item.icon !== undefined)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(item.icon)
                      }, null, 2))
                    : _createCommentVNode("", true),
                  (item.modalName)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createTextVNode(_toDisplayString(item.text == "automationServer.newAutomation" ? _ctx.$t(item.text) + "..." : _ctx.$t(item.text)), 1)
                      ])), [
                        [_directive_b_modal, item.modalName]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.text == "automationServer.newAutomation" ? _ctx.$t(item.text) + "..." : _ctx.$t(item.text)), 1))
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          (item.items)
            ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                key: index,
                "link-class": "menu-option"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_multi_level_drop_down_button, {
                    split: false,
                    level: _ctx.level + 1,
                    "button-label": item.text,
                    icon: item.icon,
                    items: item.items,
                    onClick: itemClicked,
                    onShow: onDropdownShow,
                    onHide: onDropdownHide
                  }, null, 8, ["level", "button-label", "icon", "items"]), [
                    [_directive_b_modal, item.modalName]
                  ])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _: 2
  }, [
    (props.level >= 1)
      ? {
          name: "button-content",
          fn: _withCtx(() => [
            (props.icon !== undefined || props.modalName)
              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                  key: 0,
                  disabled: props.disabled
                }, null, 8, _hoisted_1)), [
                  [_directive_safe_class, [props.icon]],
                  [_directive_b_modal, props.modalName]
                ])
              : _createCommentVNode("", true),
            (props.buttonLabel && !props.modalName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(props.buttonLabel)) + _toDisplayString(props.level > 1 ? "    " : ""), 1))
              : _createCommentVNode("", true),
            (props.buttonLabel && props.modalName)
              ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.$t(props.buttonLabel)) + _toDisplayString(props.level > 1 ? "    " : ""), 1)
                ])), [
                  [_directive_b_modal, props.modalName]
                ])
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class", "disabled", "dropright", "split", "id", "text", "offset"]))
}
}

})